import { Category, Item, Modifier, ModifierGroup } from '../models';
import i18next from 'i18next';

export const UNCATEGORIZED = 'UNCATEGORIZED';

export type RawItem = Omit<Item, 'modifierGroups' | 'taxes' | 'categories' | 'pricePlaceholder'> & {
  modifierGroupIds: Uuid[];
  categoryIds: Uuid[];
  taxIds: Uuid[];
};

export type RawCategory = Omit<Category, 'items'> & {
  items: string[];
};

export type RawModifierGroup = Omit<ModifierGroup, 'minRequired' | 'maxAllowed'> & {
  minRequired?: number;
  maxAllowed?: number;
};

export type RawModifier = Omit<Modifier, 'group' | 'minRequired' | 'maxAllowed'> & {
  groupId: Uuid;
};

export type MenuDataTransferable = {
  categories: IdMap<RawCategory>;
  modifierGroups: IdMap<RawModifierGroup>;
  modifiers: RawModifier[];
  items: RawItem[];
};

// sort order is MAX_SAFE_INTEGER because it should be displayed as the last category
export const UNCATEGORIZED_CATEGORY: Category = {
  id: UNCATEGORIZED,
  name: i18next.t('uncategorized'),
  sortOrder: Number.MAX_SAFE_INTEGER,
  items: []
};
